import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=5477fdb2&scoped=true&"
import script from "./messageList.vue?vue&type=script&lang=js&"
export * from "./messageList.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/nav.less?vue&type=style&index=0&id=5477fdb2&scoped=true&lang=less&"
import style1 from "../../assets/css/common/table.less?vue&type=style&index=1&id=5477fdb2&scoped=true&lang=less&"
import style2 from "./messageList.vue?vue&type=style&index=2&id=5477fdb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477fdb2",
  null
  
)

export default component.exports